<template>
  <div class="fish-admin">
    <!-- 头部标题 -->
    <div class="admin-header">
      <h1>🐟 观背青鳉爱心兑换管理系统</h1>
      <div class="header-stats">
        <div class="stat-card" v-for="stat in statsList" :key="stat.label">
          <div class="stat-value">{{ stat.value }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
        <button class="open-modal-btn" @click="openModal">
          ⚙️ 活动开关设置
        </button>
      </div>
    </div>

    <!-- 弹框 -->
    <div class="modal" v-if="modalVisible" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>⚙️ 更新设置</h3>
          <span class="close-btn" @click="closeModal">&times;</span>
        </div>

        <div class="modal-body">
          <div class="settings-form">
            <input type="hidden" v-model="settingId" />

            <div class="form-group">
              <label>图片URL:</label>
              <input
                type="text"
                v-model="formData.image_url"
                placeholder="请输入图片地址"
              />
            </div>

            <div class="form-group">
              <label>标题:</label>
              <input
                type="text"
                v-model="formData.title"
                placeholder="请输入标题"
              />
            </div>

            <div class="form-group">
              <label>是否可见:</label>
              <select v-model="formData.is_visible">
                <option :value="1">可见</option>
                <option :value="0">隐藏</option>
              </select>
            </div>

            <!-- 提示消息 -->
            <span v-if="resultMsg" :class="['result-msg', resultType]">
              {{ resultMsg }}
            </span>
          </div>
        </div>

        <div class="modal-footer">
          <button class="cancel-btn" @click="closeModal">取消</button>
          <button
            class="update-btn"
            @click="updateSettings"
            :disabled="loading"
          >
            {{ loading ? "更新中..." : "更新设置" }}
          </button>
        </div>
      </div>
    </div>

    <!-- Tab 切换 -->
    <div class="tabs">
      <div
        class="tab-item"
        :class="{ active: activeTab === 'product' }"
        @click="
          activeTab = 'product';
          handleTabClick('product');
        "
      >
        商品管理
      </div>
      <div
        class="tab-item"
        :class="{ active: activeTab === 'order' }"
        @click="
          activeTab = 'order';
          handleTabClick('order');
        "
      >
        订单管理
      </div>
      <div
        class="tab-item"
        :class="{ active: activeTab === 'shipping' }"
        @click="
          activeTab = 'shipping';
          handleTabClick('shipping');
        "
      >
        运费配置
      </div>
    </div>

    <!-- 商品管理 Tab -->
    <div class="tab-content" v-show="activeTab === 'product'">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <input
          type="text"
          v-model="productSearch.keyword"
          placeholder="搜索商品名称"
          class="search-input"
          @keyup.enter="loadProducts"
        />
        <select v-model="productSearch.status" class="search-select">
          <option value="">全部状态</option>
          <option :value="1">上架</option>
          <option :value="0">下架</option>
        </select>
        <button class="btn btn-primary" @click="loadProducts">搜索</button>
        <button class="btn btn-success" @click="openProductDialog()">
          新增商品
        </button>
        <button
          class="btn btn-danger"
          :disabled="selectedProductIds.length === 0"
          @click="batchDeleteProducts"
        >
          批量下架
        </button>
      </div>

      <!-- 商品表格 -->
      <table class="data-table">
        <thead>
          <tr>
            <th width="50">
              <input type="checkbox" @change="selectAllProducts" />
            </th>
            <th>ID</th>
            <th>图片</th>
            <th>商品名称</th>
            <th>爱心价格</th>
            <th>原价(¥)</th>
            <th>库存</th>
            <th>排序</th>
            <th>状态</th>
            <th width="200">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in productList" :key="item.id">
            <td>
              <input
                type="checkbox"
                v-model="selectedProductIds"
                :value="item.id"
              />
            </td>
            <td>{{ item.id }}</td>
            <td><img :src="item.img" class="table-img" /></td>
            <td>{{ item.name }}</td>
            <td>❤️ {{ item.price }}</td>
            <td>¥{{ item.original_price }}</td>
            <td>{{ item.stock }}</td>
            <td>{{ item.sort_order }}</td>
            <td>
              <span
                class="badge"
                :class="item.status === 1 ? 'badge-success' : 'badge-danger'"
              >
                {{ item.status === 1 ? "上架" : "下架" }}
              </span>
            </td>
            <td>
              <button
                class="btn btn-sm btn-primary"
                @click="openProductDialog(item)"
              >
                编辑
              </button>
              <button
                class="btn btn-sm btn-warning"
                @click="openStockDialog(item)"
              >
                修改库存
              </button>
              <button
                class="btn btn-sm btn-danger"
                @click="
                  deleteProduct(item.id, item.status === 1 ? '下架' : '删除')
                "
              >
                {{ item.status === 1 ? "下架" : "删除" }}
              </button>
            </td>
          </tr>
          <tr v-if="productList.length === 0">
            <td colspan="10" class="text-center">暂无数据</td>
          </tr>
        </tbody>
      </table>

      <!-- 分页 -->
      <div class="pagination">
        <button
          class="btn btn-sm"
          :disabled="productPage.page === 1"
          @click="
            productPage.page--;
            loadProducts();
          "
        >
          上一页
        </button>
        <span class="page-info"
          >第 {{ productPage.page }} 页 / 共
          {{ Math.ceil(productTotal / productPage.pageSize) }} 页</span
        >
        <button
          class="btn btn-sm"
          :disabled="
            productPage.page >= Math.ceil(productTotal / productPage.pageSize)
          "
          @click="
            productPage.page++;
            loadProducts();
          "
        >
          下一页
        </button>
        <select
          v-model="productPage.pageSize"
          @change="
            productPage.page = 1;
            loadProducts();
          "
          class="page-size"
        >
          <option :value="10">10条/页</option>
          <option :value="20">20条/页</option>
          <option :value="50">50条/页</option>
        </select>
      </div>
    </div>

    <!-- 订单管理 Tab -->
    <div class="tab-content" v-show="activeTab === 'order'">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <input
          type="text"
          v-model="orderSearch.keyword"
          placeholder="搜索订单号/收货人/手机号/UID"
          class="search-input"
          style="width: 250px"
          @keyup.enter="loadOrders"
        />
        <select v-model="orderSearch.status" class="search-select">
          <option value="">全部状态</option>
          <option :value="0">待处理</option>
          <option :value="1">已确认</option>
          <option :value="2">已发货</option>
          <option :value="3">已完成</option>
          <option :value="4">已取消</option>
        </select>
        <input
          type="date"
          v-model="orderSearch.startDate"
          class="search-input"
          placeholder="开始日期"
        />
        <span>-</span>
        <input
          type="date"
          v-model="orderSearch.endDate"
          class="search-input"
          placeholder="结束日期"
        />
        <button class="btn btn-primary" @click="loadOrders">搜索</button>
        <button class="btn btn-success" @click="exportOrders">导出订单</button>
        <button
          class="btn btn-danger"
          :disabled="selectedOrderIds.length === 0"
          @click="batchUpdateStatus(4)"
        >
          批量取消
        </button>
      </div>

      <!-- 订单表格 -->
      <table class="data-table">
        <thead>
          <tr>
            <th width="50">
              <input type="checkbox" @change="selectAllOrders" />
            </th>
            <th>订单号</th>
            <th>用户UID</th>
            <th>总金额</th>
            <th>状态</th>
            <th>收货人</th>
            <th>手机号</th>
            <th>下单时间</th>
            <th width="280">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in orderList" :key="item.id">
            <td>
              <input
                type="checkbox"
                v-model="selectedOrderIds"
                :value="item.id"
              />
            </td>
            <td>{{ item.order_no }}</td>
            <td>{{ item.user_id }}</td>
            <td>❤️ {{ item.total_amount }}</td>
            <td>
              <span class="badge" :class="getOrderStatusClass(item.status)">
                {{ getOrderStatusText(item.status) }}
              </span>
            </td>
            <td>{{ item.contact_name || "-" }}</td>
            <td>{{ item.contact_phone || "-" }}</td>
            <td>{{ formatDate(item.created_at) }}</td>
            <td>
              <button
                class="btn btn-sm btn-info"
                @click="viewOrderDetail(item)"
              >
                详情
              </button>
              <button
                v-if="item.status === 0"
                class="btn btn-sm btn-primary"
                @click="updateOrderStatus(item.id, 1)"
              >
                确认订单
              </button>
              <button
                v-if="item.status === 1"
                class="btn btn-sm btn-warning"
                @click="updateOrderStatus(item.id, 2)"
              >
                发货
              </button>
              <button
                v-if="item.status === 2"
                class="btn btn-sm btn-success"
                @click="updateOrderStatus(item.id, 3)"
              >
                完成
              </button>
              <button
                v-if="item.status === 0"
                class="btn btn-sm btn-danger"
                @click="updateOrderStatus(item.id, 4)"
              >
                取消
              </button>
            </td>
          </tr>
          <tr v-if="orderList.length === 0">
            <td colspan="10" class="text-center">暂无数据</td>
          </tr>
        </tbody>
      </table>

      <!-- 分页 -->
      <div class="pagination">
        <button
          class="btn btn-sm"
          :disabled="orderPage.page === 1"
          @click="
            orderPage.page--;
            loadOrders();
          "
        >
          上一页
        </button>
        <span class="page-info"
          >第 {{ orderPage.page }} 页 / 共
          {{ Math.ceil(orderTotal / orderPage.pageSize) }} 页</span
        >
        <button
          class="btn btn-sm"
          :disabled="
            orderPage.page >= Math.ceil(orderTotal / orderPage.pageSize)
          "
          @click="
            orderPage.page++;
            loadOrders();
          "
        >
          下一页
        </button>
        <select
          v-model="orderPage.pageSize"
          @change="
            orderPage.page = 1;
            loadOrders();
          "
          class="page-size"
        >
          <option :value="10">10条/页</option>
          <option :value="20">20条/页</option>
          <option :value="50">50条/页</option>
        </select>
      </div>
    </div>

    <!-- 运费配置 Tab -->
    <div class="tab-content" v-show="activeTab === 'shipping'">
      <div class="shipping-config">
        <div class="form-group">
          <label>名称</label>
          <input type="text" v-model="shippingForm.name" class="form-input" />
        </div>
        <div class="form-group">
          <label>爱心价格</label>
          <input
            type="number"
            v-model="shippingForm.price"
            class="form-input"
            style="width: 200px"
          />
          <span> ❤️</span>
        </div>
        <div class="form-group">
          <label>原价(元)</label>
          <input
            type="number"
            v-model="shippingForm.original_price"
            step="0.01"
            class="form-input"
            style="width: 200px"
          />
          <span> ¥</span>
        </div>
        <div class="form-group">
          <label>描述</label>
          <textarea
            v-model="shippingForm.desc"
            rows="3"
            class="form-textarea"
            style="width: 400px"
          ></textarea>
        </div>
        <div class="form-group">
          <label>每单最多装鱼</label>
          <input
            type="number"
            v-model="shippingForm.max_fish_count"
            class="form-input"
            style="width: 200px"
          />
          <span> 条</span>
        </div>
        <div class="form-group">
          <label>状态</label>
          <label class="switch">
            <input
              type="checkbox"
              v-model="shippingForm.status"
              true-value="1"
              false-value="0"
            />
            <span class="slider"></span>
          </label>
          <span style="margin-left: 10px">{{
            shippingForm.status == 1 ? "启用" : "禁用"
          }}</span>
        </div>
        <div class="form-group">
          <button class="btn btn-primary" @click="saveShippingConfig">
            保存配置
          </button>
        </div>
      </div>
    </div>

    <!-- 商品编辑弹窗 -->
    <div
      class="modal"
      v-if="productDialogVisible"
      @click.self="productDialogVisible = false"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ productDialogTitle }}</h3>
          <span class="close" @click="productDialogVisible = false"
            >&times;</span
          >
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>商品名称 *</label>
            <input type="text" v-model="productForm.name" class="form-input" />
          </div>
          <div class="form-group">
            <label>爱心价格 *</label>
            <input
              type="number"
              v-model="productForm.price"
              class="form-input"
            />
            <span> ❤️</span>
          </div>
          <div class="form-group">
            <label>原价(元)</label>
            <input
              type="number"
              v-model="productForm.original_price"
              step="0.01"
              class="form-input"
            />
            <span> ¥</span>
          </div>
          <div class="form-group">
            <label>描述</label>
            <textarea
              v-model="productForm.desc"
              rows="3"
              class="form-textarea"
            ></textarea>
          </div>
          <div class="form-group">
            <label>图片URL</label>
            <input
              type="text"
              v-model="productForm.img"
              class="form-input"
              placeholder="请输入图片URL"
            />
            <div v-if="productForm.img" class="img-preview">
              <img :src="productForm.img" />
            </div>
          </div>
          <div class="form-group">
            <label>库存</label>
            <input
              type="number"
              v-model="productForm.stock"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label>排序</label>
            <input
              type="number"
              v-model="productForm.sort_order"
              class="form-input"
            />
            <span> 数字越小越靠前</span>
          </div>
          <div class="form-group">
            <label>状态</label>
            <label class="switch">
              <input
                type="checkbox"
                v-model="productForm.status"
                true-value="1"
                false-value="0"
              />
              <span class="slider"></span>
            </label>
            <span style="margin-left: 10px">{{
              productForm.status == 1 ? "上架" : "下架"
            }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn" @click="productDialogVisible = false">
            取消
          </button>
          <button class="btn btn-primary" @click="saveProduct">确定</button>
        </div>
      </div>
    </div>

    <!-- 修改库存弹窗 -->
    <div
      class="modal"
      v-if="stockDialogVisible"
      @click.self="stockDialogVisible = false"
    >
      <div class="modal-content" style="width: 400px">
        <div class="modal-header">
          <h3>修改库存</h3>
          <span class="close" @click="stockDialogVisible = false">&times;</span>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>商品名称</label>
            <span>{{ currentProduct && currentProduct.name }}</span>
          </div>
          <div class="form-group">
            <label>当前库存</label>
            <span>{{ currentProduct && currentProduct.stock }}</span>
          </div>
          <div class="form-group">
            <label>新库存</label>
            <input type="number" v-model="newStock" class="form-input" />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn" @click="stockDialogVisible = false">取消</button>
          <button class="btn btn-primary" @click="updateStock">确定</button>
        </div>
      </div>
    </div>
    <!-- 确认订单弹窗（填写收货信息） -->
    <div
      class="modal-overlay"
      v-if="confirmDialogVisible"
      @click.self="confirmDialogVisible = false"
    >
      <div class="modal-container">
        <div class="modal-header">
          <h3>确认订单</h3>
          <span class="modal-close" @click="confirmDialogVisible = false"
            >&times;</span
          >
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>收货人姓名 <span style="color: red">*</span></label>
            <input
              type="text"
              v-model="confirmForm.contact_name"
              class="form-input"
              placeholder="请输入收货人姓名"
            />
          </div>
          <div class="form-group">
            <label>手机号 <span style="color: red">*</span></label>
            <input
              type="tel"
              v-model="confirmForm.contact_phone"
              class="form-input"
              placeholder="请输入手机号"
            />
          </div>
          <div class="form-group">
            <label>收货地址 <span style="color: red">*</span></label>
            <textarea
              v-model="confirmForm.shipping_address"
              class="form-textarea"
              rows="3"
              placeholder="请输入收货地址"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn" @click="confirmDialogVisible = false">
            取消
          </button>
          <button class="btn btn-primary" @click="submitConfirm">确定</button>
        </div>
      </div>
    </div>

    <!-- 发货弹窗（填写快递单号） -->
    <div
      class="modal-overlay"
      v-if="shipDialogVisible"
      @click.self="shipDialogVisible = false"
    >
      <div class="modal-container" style="width: 450px">
        <div class="modal-header">
          <h3>发货</h3>
          <span class="modal-close" @click="shipDialogVisible = false"
            >&times;</span
          >
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>快递单号 <span style="color: red">*</span></label>
            <input
              type="text"
              v-model="shipForm.tracking_no"
              class="form-input"
              placeholder="请输入快递单号"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn" @click="shipDialogVisible = false">取消</button>
          <button class="btn btn-primary" @click="submitShip">确定</button>
        </div>
      </div>
    </div>

    <!-- 订单详情弹窗 -->
    <div
      class="modal"
      v-if="orderDetailVisible"
      @click.self="orderDetailVisible = false"
    >
      <div class="modal-content" style="width: 800px">
        <div class="modal-header">
          <h3>订单详情</h3>
          <span class="close" @click="orderDetailVisible = false">&times;</span>
        </div>
        <div class="modal-body" v-if="orderDetail">
          <div class="detail-info">
            <div class="detail-row">
              <span class="detail-label">订单号：</span
              >{{ orderDetail.order_no }}
            </div>
            <div class="detail-row">
              <span class="detail-label">用户ID：</span
              >{{ orderDetail.user_id }}
            </div>
            <div class="detail-row">
              <span class="detail-label">总金额：</span>❤️
              {{ orderDetail.total_amount }}
            </div>
            <div class="detail-row">
              <span class="detail-label">订单状态：</span>
              <span
                class="badge"
                :class="getOrderStatusClass(orderDetail.status)"
                >{{ getOrderStatusText(orderDetail.status) }}</span
              >
            </div>
            <div class="detail-row">
              <span class="detail-label">收货人：</span
              >{{ orderDetail.contact_name || "-" }}
            </div>
            <div class="detail-row">
              <span class="detail-label">手机号：</span
              >{{ orderDetail.contact_phone || "-" }}
            </div>
            <div class="detail-row">
              <span class="detail-label">收货地址：</span
              >{{ orderDetail.shipping_address || "-" }}
            </div>
            <div class="detail-row">
              <span class="detail-label">备注：</span
              >{{ orderDetail.remark || "-" }}
            </div>
            <div class="detail-row">
              <span class="detail-label">下单时间：</span
              >{{ orderDetail.created_at }}
            </div>
          </div>
          <h4>商品明细</h4>
          <table class="data-table">
            <thead>
              <tr>
                <th>商品名称</th>
                <th>类型</th>
                <th>单价</th>
                <th>数量</th>
                <th>小计</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in orderDetail.items" :key="item.id">
                <td>{{ item.product_name }}</td>
                <td>
                  <span
                    class="badge"
                    :class="
                      item.product_type === 'fish'
                        ? 'badge-primary'
                        : 'badge-success'
                    "
                  >
                    {{ item.product_type === "fish" ? "鱼" : "运费" }}
                  </span>
                </td>
                <td>❤️ {{ item.price }}</td>
                <td>{{ item.quantity }}</td>
                <td>❤️ {{ item.total_price }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getFishProducts,
  addFishProduct,
  updateFishProduct,
  deleteFishProduct,
  batchDeleteFishProducts,
  updateFishProductStock,
  getShippingConfig,
  updateShippingConfig,
  getOrders,
  getOrderDetail,
  updateOrderStatus,
  batchUpdateOrderStatus,
  getOrderStats,
  exportOrders,
  confirmOrder,
  shipOrder,
  getSettingsList,
  updateSettings,
} from "@/api/houtai/fish.js";

export default {
  name: "FishAdmin",
  data() {
    return {
      activeTab: "product",

      // 商品管理
      productList: [],
      productTotal: 0,
      productPage: { page: 1, pageSize: 10 },
      productSearch: { keyword: "", status: "" },
      selectedProductIds: [],

      // 商品弹窗
      productDialogVisible: false,
      productDialogTitle: "新增商品",
      productForm: {
        id: null,
        name: "",
        price: 0,
        original_price: 0,
        desc: "",
        img: "",
        stock: 0,
        sort_order: 0,
        status: 1,
      },

      // 库存弹窗
      stockDialogVisible: false,
      currentProduct: null,
      newStock: 0,

      // 订单管理
      orderList: [],
      orderTotal: 0,
      orderPage: { page: 1, pageSize: 10 },
      orderSearch: { keyword: "", status: "", startDate: "", endDate: "" },
      selectedOrderIds: [],
      orderDetailVisible: false,
      orderDetail: null,

      // 运费配置
      shippingForm: {
        name: "免运费",
        price: 999999,
        original_price: 9.9,
        desc: "快递/打包-为保证小鱼安全送达",
        max_fish_count: 12,
        status: 1,
      },

      // 统计数据
      stats: {
        total_orders: 0,
        pending_count: 0,
        confirmed_count: 0,
        shipped_count: 0,
        completed_count: 0,
        cancelled_count: 0,
        total_amount: 0,
      },

      // 确认订单弹窗
      confirmDialogVisible: false,
      currentOrderId: null,
      confirmForm: {
        contact_name: "",
        contact_phone: "",
        shipping_address: "",
      },

      // 发货弹窗
      shipDialogVisible: false,
      shipForm: {
        tracking_no: "",
      },
      modalVisible: false,
      loading: false,
      settingId: 1,
      formData: {
        image_url: "",
        title: "",
        is_visible: 1,
      },
      resultMsg: "",
      resultType: "", // success 或 error
    };
  },
  computed: {
    statsList() {
      return [
        { label: "总订单", value: this.stats.total_orders },
        { label: "待处理", value: this.stats.pending_count },
        { label: "已确认", value: this.stats.confirmed_count },
        { label: "已发货", value: this.stats.shipped_count },
        { label: "已完成", value: this.stats.completed_count },
        { label: "已取消", value: this.stats.cancelled_count },
        { label: "总爱心", value: this.stats.total_amount },
      ];
    },
  },
  mounted() {
    this.loadProducts();
    this.loadStats();
  },
  methods: {
    // 加载当前设置数据
    async loadCurrentSettings() {
      try {
        // 使用 API 方法
        const response = await getSettingsList(0); // 0 表示获取所有数据
        const result = response.data;
        console.log("加载设置列表:", result);

        if (result) {
          // 取第一条数据
          const settings = result[0];
          this.formData = {
            image_url: settings.image_url || "",
            title: settings.title || "",
            is_visible:
              settings.is_visible !== undefined ? settings.is_visible : 1,
          };
          this.settingId = settings.id;
          console.log("加载设置成功:", this.formData);
        } else {
          // 没有数据时使用默认值
          console.log("暂无设置数据，使用默认值");
          this.formData = {
            image_url: "",
            title: "",
            is_visible: 1,
          };
          this.settingId = 1;
        }
      } catch (error) {
        console.error("加载设置失败:", error);
        // 加载失败时使用默认值
        this.formData = {
          image_url: "",
          title: "",
          is_visible: 1,
        };
        this.settingId = 1;
      }
    },
    // 更新设置
    async updateSettings() {
      if (!this.formData.title || !this.formData.title.trim()) {
        this.showMessage("❌ 标题不能为空", "error");
        return;
      }
      // 添加日志，查看传递的值
      console.log("传递的参数:", {
        settingId: this.settingId,
        image_url: this.formData.image_url,
        title: this.formData.title,
        is_visible: this.formData.is_visible,
      });
      this.loading = true;

      try {
        const response = await updateSettings(this.settingId, {
          image_url: this.formData.image_url || "",
          title: this.formData.title || "",
          is_visible: parseInt(this.formData.is_visible) || 1,
        });
        if (response.status === 200) {
          this.showMessage("✅ 更新成功！", "success");
          setTimeout(() => {
            this.closeModal();
          }, 1500);
        } else {
          this.showMessage(`❌ 更新失败：${response.data.msg}`, "error");
        }
      } catch (error) {
        console.error("请求失败:", error);
        this.showMessage("❌ 网络错误，请检查网络连接", "error");
      } finally {
        this.loading = false;
      }
    },
    // 打开弹框
    openModal() {
      this.modalVisible = true;
      this.clearMessage();
      // 可选：加载当前设置数据
      this.loadCurrentSettings();
    },

    // 关闭弹框
    closeModal() {
      this.modalVisible = false;
      this.resetForm();
    },

    // 重置表单
    resetForm() {
      this.formData = {
        image_url: "",
        title: "",
        is_visible: 1,
      };
      this.clearMessage();
    },

    // 清除提示消息
    clearMessage() {
      this.resultMsg = "";
      this.resultType = "";
    },

    // 显示消息
    showMessage(message, type) {
      this.resultMsg = message;
      this.resultType = type;

      // 3秒后自动清除
      setTimeout(() => {
        if (this.resultMsg === message) {
          this.clearMessage();
        }
      }, 3000);
    },

    // 格式化时间
    formatDate(dateTime) {
      if (!dateTime) return "-";
      const date = new Date(dateTime);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 打开确认订单弹窗
    openConfirmDialog(orderId) {
      this.currentOrderId = orderId;
      this.confirmForm = {
        contact_name: "",
        contact_phone: "",
        shipping_address: "",
      };
      this.confirmDialogVisible = true;
    },

    // 提交确认订单
    async submitConfirm() {
      if (!this.confirmForm.contact_name) {
        alert("请输入收货人姓名");
        return;
      }
      if (!this.confirmForm.contact_phone) {
        alert("请输入手机号");
        return;
      }
      if (!this.confirmForm.shipping_address) {
        alert("请输入收货地址");
        return;
      }

      try {
        const res = await confirmOrder(
          this.currentOrderId,
          this.confirmForm.contact_name,
          this.confirmForm.contact_phone,
          this.confirmForm.shipping_address
        );
        if (res.status === 200) {
          alert(res.msg);
          this.confirmDialogVisible = false;
          this.loadOrders();
          this.loadStats();
        } else {
          alert(res.msg);
        }
      } catch (error) {
        console.error("确认订单失败", error);
        alert("操作失败");
      }
    },

    // 打开发货弹窗
    openShipDialog(orderId) {
      this.currentOrderId = orderId;
      this.shipForm = { tracking_no: "" };
      this.shipDialogVisible = true;
    },

    // 提交发货
    async submitShip() {
      if (!this.shipForm.tracking_no) {
        alert("请输入快递单号");
        return;
      }

      try {
        const res = await shipOrder(
          this.currentOrderId,
          this.shipForm.tracking_no
        );
        if (res.status === 200) {
          alert(res.msg);
          this.shipDialogVisible = false;
          this.loadOrders();
          this.loadStats();
        } else {
          alert(res.msg);
        }
      } catch (error) {
        console.error("发货失败", error);
        alert("操作失败");
      }
    },

    // 修改原有的 updateOrderStatus 方法
    async updateOrderStatus(id, status) {
      // 如果是确认订单（状态1），打开弹窗填写收货信息
      if (status === 1) {
        this.openConfirmDialog(id);
        return;
      }

      // 如果是发货（状态2），打开弹窗填写快递单号
      if (status === 2) {
        this.openShipDialog(id);
        return;
      }

      // 其他状态（完成、取消）直接确认
      const statusText = this.getOrderStatusText(status);
      if (confirm(`确定要将订单状态更新为"${statusText}"吗？`)) {
        try {
          const res = await updateOrderStatus(id, status);
          if (res.status === 200) {
            alert(res.msg);
            this.loadOrders();
            this.loadStats();
          } else {
            alert(res.msg);
          }
        } catch (error) {
          console.error("更新状态失败", error);
          alert("操作失败");
        }
      }
    },

    // 确认框
    async confirmMsg(msg) {
      return confirm(msg);
    },

    // 订单状态
    getOrderStatusText(status) {
      const map = {
        0: "待处理",
        1: "已确认",
        2: "已发货",
        3: "已完成",
        4: "已取消",
      };
      return map[status] || "未知";
    },
    getOrderStatusClass(status) {
      const map = {
        0: "badge-info",
        1: "badge-primary",
        2: "badge-warning",
        3: "badge-success",
        4: "badge-danger",
      };
      return map[status] || "badge-info";
    },

    // 全选
    selectAllProducts(e) {
      if (e.target.checked) {
        this.selectedProductIds = this.productList.map((v) => v.id);
      } else {
        this.selectedProductIds = [];
      }
    },
    selectAllOrders(e) {
      if (e.target.checked) {
        this.selectedOrderIds = this.orderList.map((v) => v.id);
      } else {
        this.selectedOrderIds = [];
      }
    },

    // ==================== 商品管理 ====================
    async loadProducts() {
      try {
        const res = await getFishProducts(
          this.productPage.page,
          this.productPage.pageSize,
          this.productSearch.status,
          this.productSearch.keyword
        );

        console.log("加载商品响应", res);
        if (res.status === 200) {
          this.productList = res.data || [];
          this.productTotal = res.total || 0;
        }
      } catch (error) {
        console.error("加载商品失败", error);
        alert("加载商品失败");
      }
    },

    openProductDialog(row) {
      if (row) {
        this.productDialogTitle = "编辑商品";
        Object.assign(this.productForm, row);
      } else {
        this.productDialogTitle = "新增商品";
        Object.assign(this.productForm, {
          id: null,
          name: "",
          price: 0,
          original_price: 0,
          desc: "",
          img: "",
          stock: 0,
          sort_order: 0,
          status: 1,
        });
      }
      this.productDialogVisible = true;
    },

    async saveProduct() {
      if (!this.productForm.name) {
        alert("请输入商品名称");
        return;
      }
      if (!this.productForm.price && this.productForm.price !== 0) {
        alert("请输入爱心价格");
        return;
      }

      try {
        let res;
        if (this.productForm.id) {
          res = await updateFishProduct(this.productForm.id, this.productForm);
        } else {
          res = await addFishProduct(this.productForm);
        }
        if (res.status === 200) {
          alert(res.msg);
          this.productDialogVisible = false;
          this.loadProducts();
        } else {
          alert(res.msg);
        }
      } catch (error) {
        console.error("保存商品失败", error);
        alert("保存失败");
      }
    },

    openStockDialog(row) {
      this.currentProduct = row;
      this.newStock = row.stock;
      this.stockDialogVisible = true;
    },

    async updateStock() {
      try {
        const res = await updateFishProductStock(
          this.currentProduct.id,
          this.newStock
        );
        if (res.status === 200) {
          alert("库存更新成功");
          this.stockDialogVisible = false;
          this.loadProducts();
        } else {
          alert(res.msg);
        }
      } catch (error) {
        console.error("更新库存失败", error);
        alert("更新失败");
      }
    },

    async deleteProduct(id, action) {
      if (confirm(`确定要${action}该商品吗？`)) {
        try {
          const res = await deleteFishProduct(
            id,
            action === "下架" ? "soft" : "hard"
          );
          if (res.status === 200) {
            alert(res.msg);
            this.loadProducts();
          } else {
            alert(res.msg);
          }
        } catch (error) {
          console.error("操作失败", error);
          alert("操作失败");
        }
      }
    },

    async batchDeleteProducts() {
      if (
        confirm(`确定要下架选中的 ${this.selectedProductIds.length} 个商品吗？`)
      ) {
        try {
          const res = await batchDeleteFishProducts(
            this.selectedProductIds,
            "soft"
          );
          if (res.status === 200) {
            alert(res.msg);
            this.selectedProductIds = [];
            this.loadProducts();
          } else {
            alert(res.msg);
          }
        } catch (error) {
          console.error("批量下架失败", error);
          alert("操作失败");
        }
      }
    },

    // ==================== 订单管理 ====================
    async loadOrders() {
      try {
        const res = await getOrders(
          this.orderPage.page,
          this.orderPage.pageSize,
          this.orderSearch.status,
          this.orderSearch.keyword,
          this.orderSearch.startDate,
          this.orderSearch.endDate,
          this.orderSearch.userId // 传递用户ID
        );
        console.log("加载订单响应", res);
        if (res.status === 200) {
          this.orderList = res.data || [];
          this.orderTotal = res.total || 0;
        }
      } catch (error) {
        console.error("加载订单失败", error);
        alert("加载订单失败");
      }
    },

    async viewOrderDetail(row) {
      try {
        const res = await getOrderDetail(row.id);

        console.log("订单详情响应", res);
        if (res.status === 200) {
          this.orderDetail = res.data;
          this.orderDetailVisible = true;
        }
      } catch (error) {
        console.error("获取订单详情失败", error);
        alert("获取订单详情失败");
      }
    },

    async batchUpdateStatus(status) {
      const statusText = this.getOrderStatusText(status);
      if (
        confirm(
          `确定要将选中的 ${this.selectedOrderIds.length} 个订单状态更新为"${statusText}"吗？`
        )
      ) {
        try {
          const res = await batchUpdateOrderStatus(
            this.selectedOrderIds,
            status
          );
          if (res.status === 200) {
            alert(res.msg);
            this.selectedOrderIds = [];
            this.loadOrders();
            this.loadStats();
          } else {
            alert(res.msg);
          }
        } catch (error) {
          console.error("批量更新失败", error);
          alert("操作失败");
        }
      }
    },

    async exportOrders() {
      try {
        const res = await exportOrders({
          status: this.orderSearch.status,
          keyword: this.orderSearch.keyword,
          startDate: this.orderSearch.startDate,
          endDate: this.orderSearch.endDate,
        });
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `订单导出_${new Date().toLocaleDateString()}.xls`;
        a.click();
        URL.revokeObjectURL(url);
        alert("导出成功");
      } catch (error) {
        console.error("导出失败", error);
        alert("导出失败");
      }
    },

    // ==================== 运费配置 ====================
    async loadShippingConfig() {
      try {
        const res = await getShippingConfig();
        if (res.status === 200 && res.data) {
          Object.assign(this.shippingForm, res.data);
        }
      } catch (error) {
        console.error("加载运费配置失败", error);
      }
    },

    async saveShippingConfig() {
      try {
        const res = await updateShippingConfig(this.shippingForm);
        if (res.status === 200) {
          alert("保存成功");
        } else {
          alert(res.msg);
        }
      } catch (error) {
        console.error("保存失败", error);
        alert("保存失败");
      }
    },

    // ==================== 统计数据 ====================
    async loadStats() {
      try {
        const res = await getOrderStats();
        if (res.status === 200) {
          this.stats = res.data;
        }
      } catch (error) {
        console.error("加载统计失败", error);
      }
    },

    // Tab切换
    handleTabClick(tab) {
      if (tab === "product") {
        this.loadProducts();
      } else if (tab === "order") {
        this.loadOrders();
        this.loadStats();
      } else if (tab === "shipping") {
        this.loadShippingConfig();
      }
    },
  },
};
</script>

<style scoped>
/* 弹框样式 */
.modal {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background-color: #fff;
  margin: 10% auto;
  padding: 0;
  width: 90%;
  max-width: 500px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.close-btn {
  font-size: 28px;
  font-weight: bold;
  color: #999;
  cursor: pointer;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 24px;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* 表单样式 */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #4caf50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.1);
}

/* 按钮样式 */
.open-modal-btn {
  padding: 12px 24px;
  background-color: #f0fff0;
  color: rgb(239, 90, 90);
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  margin: 20px;
}

.open-modal-btn:hover {
  background-color: #d1f6d1;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.update-btn {
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.update-btn:hover:not(:disabled) {
  background-color: #45a049;
}

.update-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cancel-btn {
  padding: 10px 20px;
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.cancel-btn:hover {
  background-color: #e0e0e0;
}

.result-msg {
  display: block;
  margin-top: 12px;
  padding: 8px;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
}

.result-msg.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.result-msg.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* 响应式 */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 20% auto;
  }
}
* {
  box-sizing: border-box;
} /* 弹窗遮罩层 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* 弹窗容器 */
.modal-container {
  background: #fff;
  border-radius: 12px;
  width: 500px;
  max-width: 90%;
  max-height: 80vh;
  overflow: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 弹窗头部 */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.modal-close {
  font-size: 28px;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
  line-height: 1;
}

.modal-close:hover {
  color: #333;
}

/* 弹窗内容 */
.modal-body {
  padding: 20px;
}

/* 弹窗底部 */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #eee;
}

/* 表单样式 */
.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: #409eff;
}

.form-textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
  font-family: inherit;
}

.form-textarea:focus {
  outline: none;
  border-color: #409eff;
}

/* 按钮样式 */
.btn {
  padding: 8px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  background: #f0f0f0;
  color: #333;
}

.btn:hover {
  background: #e0e0e0;
}

.btn-primary {
  background: #409eff;
  color: white;
}

.btn-primary:hover {
  background: #66b1ff;
}

.fish-admin {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;
}

/* 头部 */
.admin-header {
  background: linear-gradient(135deg, #e91e63, #ff6b6b);
  border-radius: 16px;
  padding: 20px 30px;
  margin-bottom: 20px;
  color: white;
}

.admin-header h1 {
  margin: 0 0 15px 0;
  font-size: 24px;
}

.header-stats {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.stat-card {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 12px 24px;
  text-align: center;
  min-width: 80px;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
}

.stat-label {
  font-size: 12px;
  opacity: 0.9;
  margin-top: 5px;
}

/* Tabs */
.tabs {
  display: flex;
  gap: 5px;
  margin-bottom: 20px;
  background: white;
  border-radius: 12px;
  padding: 5px;
}

.tab-item {
  padding: 12px 24px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s;
}

.tab-item:hover {
  background: #f0f0f0;
}

.tab-item.active {
  background: #e91e63;
  color: white;
}

/* 内容区 */
.tab-content {
  background: white;
  border-radius: 12px;
  padding: 20px;
}

/* 搜索栏 */
.search-bar {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
}

.search-input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

.search-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
}

/* 按钮 */
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.btn-sm {
  padding: 4px 10px;
  font-size: 12px;
}

.btn-primary {
  background: #409eff;
  color: white;
}
.btn-primary:hover {
  background: #66b1ff;
}

.btn-success {
  background: #67c23a;
  color: white;
}
.btn-success:hover {
  background: #85ce61;
}

.btn-danger {
  background: #f56c6c;
  color: white;
}
.btn-danger:hover {
  background: #f78989;
}
.btn-danger:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-warning {
  background: #e6a23c;
  color: white;
}
.btn-warning:hover {
  background: #ebb563;
}

.btn-info {
  background: #909399;
  color: white;
}
.btn-info:hover {
  background: #a6a9ad;
}

/* 表格 */
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.data-table th,
.data-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.data-table th {
  background: #fafafa;
  font-weight: 600;
}

.data-table tr:hover {
  background: #fafafa;
}

.table-img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
}

/* 标签 */
.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.badge-success {
  background: #d4edda;
  color: #155724;
}
.badge-danger {
  background: #f8d7da;
  color: #721c24;
}
.badge-warning {
  background: #fff3cd;
  color: #856404;
}
.badge-info {
  background: #d1ecf1;
  color: #0c5460;
}
.badge-primary {
  background: #cce5ff;
  color: #004085;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  align-items: center;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.page-size {
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* 表单 */
.form-group {
  margin-bottom: 16px;
  display: flex;
  align-content: center;
  gap: 12px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  text-align: right;
  font-weight: 500;
  width: 120px;
}

.form-input {
  width: 100%;
  max-width: 400px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

.form-textarea {
  width: 100%;
  max-width: 500px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
}

/* 开关 */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #e91e63;
}

input:checked + .slider:before {
  transform: translateX(90px);
}

/* 弹窗 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 600px;
  max-width: 90%;
  max-height: 80vh;
  overflow: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
}

.close {
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* 订单详情 */
.detail-info {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.detail-row {
  margin-bottom: 10px;
}

.detail-label {
  font-weight: 600;
  width: 100px;
  display: inline-block;
}

.img-preview img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-top: 10px;
  border-radius: 8px;
}

.text-center {
  text-align: center;
}
</style>